export function generateUUID() {
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export function compareAlpha(a, b) {
  return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
}

export function compareInt(a, b) {
  return parseInt(a) - parseInt(b);
}

export function compareDates(a, b) {
  return new Date(a) < new Date(b) ? -1 : 1;
}

export function mapDataPointToChartDataSet(dataPointArray, decimalPoints) {
  if (!decimalPoints) {
    decimalPoints = 1;
  }
  //let series = [...new Set(dataPointArray.map(d => d.seriesName))];
  let series = [...new Set(dataPointArray.map(d => d.seriesName))].map(d => ({label: d, type: 'number' }));
  let sortedArray = dataPointArray.sort((a, b) => {
    return a.categorySort - b.categorySort;
  });

  let dataSet = [];
  sortedArray.forEach(val => {
    if (dataSet.length === 0) {
      dataSet.push(["Category", ...series]);
    }

    let row = dataSet.find(a => a[0] == val.categoryName);
    if (row === undefined) {
      // eslint-disable-next-line
      row = [val.categoryName, ...series.map(s => null)];
      dataSet.push(row);
    }

    let idxToUpdate = series.findIndex(i => i.label === val.seriesName); // .indexOf(val.seriesName);
    row[idxToUpdate + 1] += typeof(val.value) == "number" ? + (val.value.toFixed(decimalPoints)) : val.value;
  });

  return this.addAnnotationColumns(dataSet);
}

export function handleGridlines(container) {
  var gridLines = container.getElementsByTagName('rect');
  Array.prototype.forEach.call(gridLines, function(line) {
    //Format Gridlines as a dotted line
    if (line.getAttribute('fill') === '#c4c4c4') {
      line.setAttribute('fill', 'url(#pattern-fill) #c4c4c4');
    }
    // H-Axis grey instead of black
    else if(line.getAttribute('fill') === '#333333') {
      line.setAttribute('fill', '#c4c4c4');
    }
  });
}

export function handleAxisText(container) {
  var labels = container.getElementsByTagName('text');
  Array.prototype.forEach.call(labels, function(label) {
    // Lower the h-axis items
    if (label.getAttribute('text-anchor') === 'middle') {
      label.setAttribute('y', parseFloat(label.getAttribute('y')) + 15);
    }
    else if (label.getAttribute('text-anchor') === 'end') {
      label.setAttribute('x', parseFloat(label.getAttribute('x') - 10))
    }
  });
}

export function addAnnotationColumns(dataSetArray) {
  let headerRow = [];
  for (let r = 0; r < dataSetArray.length; r++) {
    let row = dataSetArray[r];
    let dataIdx = row.length - 1;
    for (let i = dataIdx; i > 0; i--) {
      //let val = null;
      let style = null;
      if (r == 0) {
        headerRow.push(...row);
        //val = { role: "annotation" };
        style = { role: "style" }
      } else {
        //val = row[i] !== null ? row[i].toFixed(1) : null;
        style = this.getSeriesColor(headerRow[i].label);
      }
      //row.splice(i + 1, 0, val);
      row.splice(i + 1, 0, style);

    }
  }
  return dataSetArray;
}
export function getSeriesColor(seriesName) {
  switch(seriesName) {
    case "Contractor":
      return "#52c8a9";
    case "Owner":
      return "#529ce3";
  }
}
export function periodNameToAPIString(periodName){
  if (!periodName){
    return null;
  }
  let date = new Date(periodName);
  return dateToAPIString(date);
}
export function dateToAPIString(date){
  if (!date){
    return null;
  }
  var pad = function(num) {
    var norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
  };
  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    'T' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds()) + ".000";
}
export function dateToPeriodName(date){
    if (!date){
      return null;
    }
    return new Date(date).toLocaleString('default', { month: 'long', year: 'numeric'});
}
export function dateToCurrentPeriodName(date){
  if (!date){
    return null;
  }
  let dt = new Date(date);
  dt.setMonth(dt.getMonth() - 1);
  return dt.toLocaleString('default', { month: 'long', year: 'numeric'});
}
export function displayDate(date){
  if (!date){
    return null;
  }
  return new Date(date).toLocaleDateString();
}
export function formatDateWithRelativeWords(timestamp) {
	if (!timestamp) return "";

	let today = new Date(),
			date = new Date(timestamp),
			todayMm = today.getMonth() + 1,
			todayDd = today.getDate(),
			todayYy = today.getFullYear() - 2000,
			mm = date.getMonth() + 1,
			dd = date.getDate(),
			yy = date.getFullYear() - 2000;

	if (todayYy === yy && todayMm === mm) {
		let daysSince = todayDd - dd;
		if (daysSince === 0) return "today";
		if (daysSince === 1) return "yesterday";
		if (daysSince === -1) return "tomorrow";
	}	

	return `${mm}/${dd}/${yy}`;
}
export function formatTime(timestamp) {
  const date = new Date( timestamp ),
    hoursOutOf24 = date.getHours(),
    minutes = date.getMinutes().toLocaleString('en-US', {
      minimumIntegerDigits: 2
    });
  
  const hours = hoursOutOf24 === 24 ? 0 :
      hoursOutOf24 > 12 ? hoursOutOf24 - 12 :
      hoursOutOf24;
  
  const amPm = hoursOutOf24 >= 12 && hoursOutOf24 != 24 ? 'pm' : 'am';
  
  return `${hours}:${minutes} ${amPm}`;
}
export function formatDollars(value) {
  if (value) {
    let str = "$";
    if (value < 0){
      str = "-$";
    }
    return str + Math.abs(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } 
  else return null;
    
}
export function APIStringToInput(date) {
  if (!date) {
    return '';
  }
  var pad = function(num) {
    var norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
  };
  date = new Date(date);
  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate());
}

export function trimObject(obj){
  if (obj && typeof obj === 'object') {
    for(let key in obj) {
      if (obj[key] && typeof obj[key] === 'string')
      obj[key] = obj[key].trim();
    }
  }

  return obj
}

export function formatErrors(err) {
  let errors = []
  if (err){
    if (err.response && err.response.data){
      if (Array.isArray(err.response.data)){
        errors = err.response.data.map(d => ({message: d}));
      } else{
        errors.push({message: err.response.data })
      }
    } else {
      errors.push({message: err.message});
    }
  }
  return errors;
}